import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/icon-arrow-back-floorplan.svg'
import _imports_1 from '@/assets/icons/close-white.svg'


const _hoisted_1 = {
  key: 0,
  class: "content-floorplan"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "house-info"
}
const _hoisted_4 = { class: "house-info-cards-wr" }
const _hoisted_5 = {
  key: 0,
  class: "house-info-card"
}
const _hoisted_6 = { class: "house-info-card-row-modified" }
const _hoisted_7 = { class: "row-value" }
const _hoisted_8 = { class: "house-info-card-row-modified" }
const _hoisted_9 = { class: "row-value" }
const _hoisted_10 = { class: "house-info-card-row-modified" }
const _hoisted_11 = { class: "row-value" }
const _hoisted_12 = {
  key: 1,
  class: "house-info-card"
}
const _hoisted_13 = { class: "house-info-card-row-modified" }
const _hoisted_14 = { class: "row-label features" }
const _hoisted_15 = {
  key: 2,
  class: "house-info-card"
}
const _hoisted_16 = { class: "house-info-card-column-modified" }
const _hoisted_17 = { class: "row-label" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "content-icon-close" }
const _hoisted_20 = { class: "content-info" }
const _hoisted_21 = { class: "house-info-card-modified" }
const _hoisted_22 = { class: "description" }
const _hoisted_23 = { class: "house-info-card-row-slider" }
const _hoisted_24 = { class: "row-value" }
const _hoisted_25 = { class: "house-info-card-row-slider" }
const _hoisted_26 = { class: "row-value" }
const _hoisted_27 = { class: "house-info-card-row-slider" }
const _hoisted_28 = { class: "row-value" }
const _hoisted_29 = {
  key: 0,
  class: "house-info-card-modified"
}
const _hoisted_30 = { class: "description" }
const _hoisted_31 = { class: "house-info-card-column-slider" }
const _hoisted_32 = { class: "row-label" }
const _hoisted_33 = {
  key: 1,
  class: "house-info-card-modified"
}
const _hoisted_34 = { class: "description" }
const _hoisted_35 = { class: "house-info-card-column-slider" }
const _hoisted_36 = { class: "row-label" }
const _hoisted_37 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.houseDesign)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "floorplan",
          src: $setup.selectedHouseDesign?.floorplans[0]?.url
        }, null, 8, _hoisted_2),
        ($setup.selectedHouseDesign && !$setup.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                ($setup.selectedHouseDesign)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "Floor Plan Area", -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_6, [
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-label" }, "Area:", -1)),
                          _createElementVNode("div", _hoisted_7, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign.area, false)) + " SQM", 1)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-label" }, "Width:", -1)),
                          _createElementVNode("div", _hoisted_9, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign.width, false)) + " M", 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-label" }, "Length:", -1)),
                          _createElementVNode("div", _hoisted_11, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign.length, false)) + " M", 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.selectedHouseDesign?.features)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "Features", -1)),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedHouseDesign.features, (feature) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(feature), 1)
                          ]))
                        }), 256))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.selectedHouseDesign.inclusions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, "Inclusions", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedHouseDesign.inclusions, ({ name, url }) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(name), 1),
                            _createElementVNode("a", {
                              class: "row-value highlighted",
                              href: url,
                              target: "_blank"
                            }, "Download", 8, _hoisted_18)
                          ])
                        ]))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.selectedHouseDesign && $setup.isDesktop && !$setup.fadeInEffectSlider)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["content-modal-floorplan", { 'slide-out': !$setup.fadeInEffectSlider }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onButtonClickSlider()))
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("img", {
                class: "logo-arrow-floorplan",
                src: _imports_0
              }, null, -1),
              _createElementVNode("div", { class: "content-text" }, "Features & Inclusions", -1)
            ]))], 2))
          : _createCommentVNode("", true),
        ($setup.selectedHouseDesign && $setup.isDesktop && $setup.fadeInEffectSlider)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["actions", { 'slide-in': $setup.fadeInEffectSlider }])
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("img", {
                  class: "logo-close",
                  src: _imports_1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onButtonClickSlider()))
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title" }, "Floor Plan Area", -1)),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row-label" }, "Area:", -1)),
                      _createElementVNode("div", _hoisted_24, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign.area, false)) + " sqm", 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row-label" }, "Width:", -1)),
                      _createElementVNode("div", _hoisted_26, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign.width, false)) + " m", 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row-label" }, "Length:", -1)),
                      _createElementVNode("div", _hoisted_28, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign.length, false)) + " m", 1)
                    ])
                  ])
                ]),
                ($setup.selectedHouseDesign?.features)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title" }, "Features", -1)),
                      _createElementVNode("div", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedHouseDesign.features, (feature) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, _toDisplayString(feature), 1)
                          ]))
                        }), 256))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.selectedHouseDesign.inclusions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title" }, "Inclusions", -1)),
                      _createElementVNode("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedHouseDesign.inclusions, ({ name, url }) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, _toDisplayString(name), 1),
                            _createElementVNode("a", {
                              class: "row-value",
                              href: url,
                              target: "_blank"
                            }, "Download", 8, _hoisted_37)
                          ]))
                        }), 256))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}